<template>
    <div>
        <el-card>
            <div class="text-[#999] text-[12px]">帖子ID：{{ detail.id }}</div>
            <div class="flex gap-x-3 mt-3">
                <img class="w-15 h-15 rounded-full"
                    src="http://gips0.baidu.com/it/u=3602773692,1512483864&fm=3028&app=3028&f=JPEG&fmt=auto?w=960&h=1280"
                    alt="avatar" />
                <div>
                    <div class="font-bold">{{ detail.userName }}</div>
                    <div class="text-[#999] text-[12px]">{{ detail.phone }}</div>
                </div>
            </div>
            <el-form class="mt-3">
                <el-form-item label="关联帖子">
                    <el-link type="primary" @click="handleToPost" :underline="false">
                        {{ detail.parentPostTitle }}
                    </el-link>
                </el-form-item>
                <el-form-item label="评论内容">
                    <div>
                        {{ detail.content }}
                    </div>
                </el-form-item>
                <el-form-item label="评论类型">
                    <span class="text-[12px] text-[#999]"> {{ detail.commentType === 1 ? '一级评论' : '二级评论' }}</span>
                    <el-tag class="ml-2" :type="detail.status === 1 ? 'success' : 'info'" size="mini">
                        {{ detail.status === 1 ? '正常' : '已下架' }}
                    </el-tag>
                </el-form-item>
                <el-form-item label="评论时间">
                    <span class="text-[#999]">{{ detail.commentTime }}</span>
                </el-form-item>
            </el-form>
        </el-card>
        <div class="mt-3">
            <el-button :type="detail.status === 1 ? 'danger' : 'primary'" @click="handleUpdateStatus">{{ detail.status === 1 ? '下架评论' : '上架评论' }}</el-button>
            <el-button type="info" @click="handleDelete">删除评论</el-button>
        </div>
    </div>
</template>

<script>
import { detail, edit, del } from "@/api/community/comment";
export default {
    name: 'CommentDetail',
    data() {
        return {
            id: '',
            detail: {},
        };
    },
    mounted() {
        this.id = this.$route.query.id;
        this.getDetail();
    },
    methods: {
        getDetail() {
            detail({ id: this.id }).then(({ code, result, message }) => {
                if (code == 200) {
                    this.detail = result;
                } else {
                    this.$message.error(message);
                }
            });
        },
        handleToPost() {
            this.$router.push({ path: "/community/post/detail", query: { id: this.detail.postId } });
        },
        handleUpdateStatus() {
            const params = {
                ...this.detail,
                status: this.detail.status === 1 ? 2 : 1,
            }
            edit(params).then(({ code, message }) => {
                if (code == 200) {
                    this.$message.success('操作成功');
                    this.getDetail();
                } else {
                    this.$message.error(message);
                }
            });
        },
        handleDelete() {
            this.$confirm("确定删除该评论吗？", "提示", { type: "warning" }).then(() => {
                del({ id: this.detail.id }).then(({ code, message }) => {
                    if (code == 200) {
                        this.$message.success('删除成功');
                        this.$router.back();
                    } else {
                        this.$message.error(message);
                    }
                });
            }).catch(() => { });
        }
    }
}
</script>